export default __webpack_public_path__ + "static/media/place-type-washing.21b21acd.svg";